const o = "A continuación, la traducción solicitada de los textos al español:", e = "Acuerdo", t = "Celebrar", c = "Completado", s = "Desacuerdo", a = "Divertido", n = "Hola", l = "Amor", i = {
  agree: o,
  celebrate: e,
  completed: t,
  disagree: c,
  funny: s,
  hi: a,
  love: n,
  wow: l
};
export {
  o as agree,
  e as celebrate,
  t as completed,
  i as default,
  c as disagree,
  s as funny,
  a as hi,
  n as love,
  l as wow
};
